import axios from '../utils/axios';

export default function getSeekerAnalysis (adminId, seekerId) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/getttl/${seekerId}`, {});
};